import { useEffect } from "react";
import { Box, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { AppRoutes } from "../../../routes/AppRoutes";
import { useLocation } from "react-router-dom";
import { useNavigateWithParams } from "../../../hooks/useNavigateWithParams";

import { useLazyGetAvailableOffersQuery } from "../../../rtk/availableOffers/availableOffers";
import { useChangeSubscriptionOfferMutation } from "../../../rtk/currentSubscriptionsOptions/currentSubscriptionsOptions";

import Footer from "../../templates/Footer/Footer";
import Header from "../../templates/Header/Header";
import EditSubscriptionChoice from "../../organisms/EditSubscriptionChoice/EditSubscriptionChoice";

import StyledButton from "../../atoms/StyledButton/StyledButton";
import SpinnerLoader from "../../atoms/SpinnerLoader/SpinnerLoader";

const ManageSubscriptionsEdit = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigateWithParams();
  const [getAvailableOffers, { isLoading, data: availableOffersData }] = useLazyGetAvailableOffersQuery();
  const [changeSubscriptionOffer, { isLoading: handleContinueLoading }] = useChangeSubscriptionOfferMutation();
  const [selectedChoice, setSelectedChoice] = useState<number | null>(null);

  const handleGoBack = () => {
    navigate(AppRoutes.MANAGE_SUBSCRIPTIONS);
  };

  useEffect(() => {
    getAvailableOffers();
  }, [getAvailableOffers]);

  const handleEditChoice = (choiceKey: number | null) => {
    setSelectedChoice(choiceKey);
  };

  const handleContinue = async () => {
    if (selectedChoice !== null && selectedChoice > 0) {
      try {
        await changeSubscriptionOffer({
          period: selectedChoice,
        }).unwrap();
        const selectedOffer = availableOffersData?.subscriptions.find(s => s.period === selectedChoice);
        navigate(AppRoutes.MANAGE_SUBSCRIPTIONS_EDIT_RESULT,
          {
            state: {
              context: "success",
              type: "subscription",
              new_period: selectedChoice,
              new_amount: selectedOffer?.amount,
              new_currency: selectedOffer?.currency,
              next_charge_at: location.state?.next_charge_at,
            }
          });
      } catch (error) {
        navigate(AppRoutes.MANAGE_SUBSCRIPTIONS_EDIT_RESULT, { state: { context: 'error' } });
      }
    } else {
      navigate(AppRoutes.MANAGE_SUBSCRIPTIONS_CANCEL_CONFIRM, {
        state: location.state
      });
    }
  };

  return (
    <>
      <Header
        headerStep={{ context: "manage" }}
        title={t("subscription:MANAGE_PAGE.EDIT_SUBSCRIPTION.HEADER")}
        goBack={handleGoBack}
      />
      <Box className="ManageSubscriptionsEdit">
        {isLoading ? <SpinnerLoader /> :
          <Stack spacing={2}>
            <EditSubscriptionChoice offers={availableOffersData} currentSubscription={location.state} onSelectionChange={handleEditChoice} />
          </Stack>
        }
      </Box>
      <Footer headerStep={{ context: "manage" }}>
        <StyledButton
          children={(isLoading || handleContinueLoading) ? <SpinnerLoader /> : t("subscription:FIRST_PAGE.BUTTON")}
          onClick={handleContinue}
          disabled={isLoading || handleContinueLoading || selectedChoice === null}
        />
      </Footer>
    </>
  );
};

export default ManageSubscriptionsEdit;
